import {Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {NotificationsService} from '@catcore/services';
import {EntitySchemaService} from '@catcore/services/entity-schema.service';
import {ResourceWizardTargetsService} from '@catcore/types/services';
import {resolveEntityNameByResourceUri} from '@catcore/utils';
import {GenericResourceService} from '@catfeatures/services/generic-resource.service';
import {NotImplementedYetComponent} from '@catuimodels/components/not-implemented-yet/not-implemented-yet.component';

@Component({
  templateUrl: './resource-wizard.component.html',
  styleUrls: ['./resource-wizard.component.scss'],
})
export class ResourceWizardComponent implements OnInit {

  jsonSchema: any = {};

  @ViewChild('widgetContainer', {read: ViewContainerRef})
  widgetContainer: ViewContainerRef;

  private formComponent: ComponentRef<any>;

  constructor(private route: ActivatedRoute,
              private resourceService: GenericResourceService,
              private schemaService: EntitySchemaService,
              private componentFactory: ComponentFactoryResolver,
              private targetService: ResourceWizardTargetsService,
              private notification: NotificationsService) {
  }

  ngOnInit() {

    this.route.queryParamMap.subscribe((queryParams) => {

      const resourceUri = queryParams.get('resource');
      const parentResourceId = queryParams.get('parentResourceId');

      if (this.formComponent) {
        this.formComponent.destroy();
      }

      const componentFactory = this.getComponentForResource(resourceUri);
      this.formComponent = this.widgetContainer.createComponent(componentFactory);
      this.jsonSchema = this.schemaService.getForResourceUri(resourceUri);
      this.formComponent.instance.resourceId = resourceUri;
      this.formComponent.instance.parentResourceId = parentResourceId;
      this.formComponent.instance.schema = this.jsonSchema;
    });
  }

  private getComponentForResource(resourceUri: string): ComponentFactory<any> {
    const entityName = resolveEntityNameByResourceUri(resourceUri);
    const modelComponents = this.targetService.getMap();

    let component = modelComponents.get(entityName);

    if (!component) {
      component = NotImplementedYetComponent;
    }

    return this.componentFactory.resolveComponentFactory(component);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/core/components/resource-wizard/resource-wizard.component.ts